// @flow

import fuzzysearch from 'fuzzysearch';

import toLowerCaseString from './toLowerCaseString';

export default (needle: string, haystack: string) => {
  needle = toLowerCaseString(needle).replace(/ /g, '');
  haystack = toLowerCaseString(haystack);
  return fuzzysearch(needle, haystack);
};
